export const SCRIPT_WORDS_PER_SECOND = 2.5

export const getRecommendedWordLength = (videoDurationSeconds: number): number => {
  const targetDurationSeconds = Math.max(videoDurationSeconds - 2, 1)
  return Math.max(Math.floor(targetDurationSeconds * SCRIPT_WORDS_PER_SECOND), 8)
}

export const countScriptWords = (script: string): number => {
  const trimmed = script.trim()
  if (!trimmed) return 0
  return trimmed.split(/\s+/).length
}
